module.exports = __webpack_public_path__ + "static/media/hk.029a6bef.svg";